import { createApp } from '@app/adapters/create-app'
import PulseInboxV2 from '@app/application/communication/screens/inbox/components/pulse-inbox-v2'
import NewRemarkButton from '@app/shared/vue/components/new-remark/new-remark-button'
import createInboxV2Store from '@app/application/communication/screens/inbox/store/inbox-v2'
import InboxFilters from '@app/application/communication/screens/inbox/components/inbox-filters'

onDomLoad(function ($dom) {
  const $addRemarkList = $dom.find("[data-behaviour~='pulse-inbox-add-remark']")

  let context = {}

  if ($addRemarkList.length > 0) {
    const $addRemark = $addRemarkList[0]
    context = {
      ownerType: 'Company',
      ownerId: Silverfin.currentCompanyId,
      ledgerId: $addRemark.getAttribute('data-ledger-id'),
      ledgerLabel: $addRemark.getAttribute('data-ledger-label'),
    }
  }

  const store = createInboxV2Store({
    companyId: context.ownerId,
    ledgerId: context.ledgerId,
    firmId: Silverfin.currentFirmId,
    companyNotificationsScope: true,
  })

  $dom.find("[data-behaviour~='pulse-inbox']").each(function () {
    const staticMarkupElement = $dom[0].querySelector(
      "[data-behaviour='pulse-inbox-static']"
    )

    const renderedHTML = staticMarkupElement.innerHTML
    const pulseInboxApp = createApp(PulseInboxV2, {
      renderedHTML,
      context,
      initialCategory: $(this).data('category'),
      initialItem: $(this).data('item'),
    })

    pulseInboxApp.use(store)
    pulseInboxApp.mount(this)

    $dom.find("[data-behaviour='inbox-filters']").each(function () {
      const filtersApp = createApp(InboxFilters, {
        showAuthorsFilter: true,
        initialSearch: $(this).data('search') || '',
        initialNoteType: $(this).data('noteType') || null,
        initialAuthors:
          $(this)
            .data('authors')
            ?.toString()
            ?.split(',')
            ?.map((value) =>
              value === 'external' ? value : Number.parseInt(value)
            ) || [],
        initialTags:
          $(this).data('tags')?.toString()?.split(',')?.map(Number.parseInt) ||
          [],
      })
      filtersApp.use(store)
      filtersApp.mount(this)
    })
  })

  $dom.find("[data-behaviour~='pulse-inbox-add-remark']").each(function () {
    const newRemarkApp = createApp(NewRemarkButton, context)

    newRemarkApp.use(store)
    newRemarkApp.mount(this)
  })
})
